import { Box } from '@mui/material';
import PropTypes from 'prop-types';

FieldContainer.propTypes = {
  children: PropTypes.node,
};

export default function FieldContainer({ children }) {
  return (
    <Box display="flex" flexDirection="column" justifyContent="space-between" height="100%">
      {children}
    </Box>
  );
}
